import dominioRouter from '@/router/sistema/dominio.router';
import perfilAcessoRouter from '@/router/sistema/perfilAcesso.router';
import permissaoRouter from '@/router/sistema/permissao.router';
import regraRouter from '@/router/sistema/regra.router';
import usuarioRouter from '@/router/sistema/usuario.router';
import parametroRouter from '@/router/sistema/parametro.router';
import tbExtensaoRouter from '@/router/sistema/tb-extensao-router';
import camposCustomizadoRouter from '@/router/sistema/campos-customizado-router';
import produtosRouter from '@/router/sistema/produtos-router';
import workflowRouter from '@/router/sistema/workflow/workflow.router';
import workflowDirecionamentoRouter from '@/router/sistema/workflow/workflow-direcionamento.router';
import workflowUsuarioRouter from '@/router/sistema/workflow/workflow-usuario.router';
import imagemLoginRouter from '@/router/sistema/imagem-login.router';

export default [
  ...dominioRouter,
  ...perfilAcessoRouter,
  ...permissaoRouter,
  ...regraRouter,
  ...tbExtensaoRouter,
  ...usuarioRouter,
  ...parametroRouter,
  ...camposCustomizadoRouter,
  ...produtosRouter,
  ...workflowRouter,
  ...workflowDirecionamentoRouter,
  ...workflowUsuarioRouter,
  ...imagemLoginRouter,
];
